var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.2 10.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M1.12,0A.47.47,0,0,0,.81.16L.11,1A.45.45,0,0,0,0,1.33a.47.47,0,0,0,.16.31L4.41,5.31a.15.15,0,0,1,0,.09.12.12,0,0,1,0,.08L.16,9.15a.47.47,0,0,0,0,.65l.7.83a.43.43,0,0,0,.31.16.42.42,0,0,0,.32-.11L7.05,5.74A.45.45,0,0,0,7.2,5.4a.47.47,0,0,0-.15-.35L1.44.11A.41.41,0,0,0,1.12,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.16ebdc78baf865637ba1b6d0f896e744.svg";
export { ForwardRef as ReactComponent };